import React from 'react';
import { useNavigate } from 'react-router-dom';
import ConfirmModal from '../components/common/ConfirmModal';
import { PATHS } from './paths';

const RequireAdmin = ({ children }) => {
  const navigate = useNavigate();
  const [isAdmin, setIsAdmin] = React.useState(false);
  const [checked, setChecked] = React.useState(false);
  const [modalOpen, setModalOpen] = React.useState(false);

  React.useEffect(() => {
    if (typeof window === 'undefined') {
      setIsAdmin(false);
      setChecked(true);
      return;
    }

    try {
      const raw = window.localStorage.getItem('currentUser');
      const parsed = raw ? JSON.parse(raw) : null;
      setIsAdmin(parsed?.role === 'ADMIN');
    } catch {
      setIsAdmin(false);
    } finally {
      setChecked(true);
    }
  }, []);

  React.useEffect(() => {
    if (checked && !isAdmin) {
      setModalOpen(true);
    }
  }, [checked, isAdmin]);

  const handleConfirm = React.useCallback(() => {
    setModalOpen(false);
    navigate(PATHS.root, { replace: true });
  }, [navigate]);

  if (!checked) {
    return null;
  }

  if (!isAdmin) {
    return (
      <ConfirmModal
        open={modalOpen}
        message="권한이 없습니다."
        confirmText="확인"
        onConfirm={handleConfirm}
      />
    );
  }

  return <>{children}</>;
};

export default RequireAdmin;

